module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"progress":{"summary":"{done} done, {left} left ({total} total)"},"status":{"complete":"complete","skipped":"skipped","incomplete":"incomplete"}},"de":{"progress":{"summary":"{done} erledigt, {left} offen ({total} gesamt)"},"status":{"complete":"vollständig","skipped":"übersprungen","incomplete":"unvollständig"}}}')
  delete Component.options._Ctor
}
